@if (routeMetadata?.backLink) {
  <a
    (click)="!isBackDisabled() && goBack()"
    [class.tw-opacity-50]="isBackDisabled()"
    [class.tw-cursor-not-allowed]="isBackDisabled()"
    [class.tw-cursor-pointer]="!isBackDisabled()"
    [class.tw-no-underline]="isBackDisabled()"
    [class.page-title__back-link--icon-only]="iconOnly"
    class="page-title__back-link tw-h-[25px] tw-flex tw-items-center tw-gap-[5px]"
  >
    <mat-icon class="medium" svgIcon="arrow-left"></mat-icon>
    @if (!iconOnly) {
      {{ routeMetadata?.backLinkText || 'Back' }}
    }
  </a>
} @else if (!routeMetadata?.hidePageHeader) {
  <h1
    id="page-title"
    class="mt-3 tw-leading-[1.2]"
    [innerHTML]="routeMetadata?.title"
  ></h1>
}
